import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Table,
	Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";

// import "../app-invoice.css";
import { getPIDocReport } from "../../../store/Reports/actions";
import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";

class PIReportDocument extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.getPIDocReport(this.props.match.params.id);
	}
	// getPDFReport() {
	//   //	297 x 210 mm
	//   const codewidth = document.getElementById("toPdf").style.width;
	//   document.getElementById("toPdf").style.width = "297mm";
	//   const doc = new jsPDF({ compress: true });
	//   doc.setDisplayMode(1);
	//   doc.html(document.getElementById("toPdf"), {
	//     callback: function (doc) {
	//       doc.save();
	//       document.getElementById("toPdf").style.width = codewidth;
	//     },
	//     x: 0,
	//     y: 0,
	//     html2canvas: { scale: 0.25 },
	//   });
	// }

	getPDFReport = async () => {
		const element = document.getElementById("toPdf");
		if (!element) return;

		const pdf = new jsPDF("p", "mm", "a4");
		const pageWidth = pdf.internal.pageSize.getWidth();
		const pageHeight = pdf.internal.pageSize.getHeight();

		const canvas = await html2canvas(element, {
			scale: 2,
			useCORS: true,
			scrollX: 0,
			scrollY: 0,
			windowWidth: element.scrollWidth,
			windowHeight: element.scrollHeight,
			backgroundColor: "#ffffff",
		});

		const imgData = canvas.toDataURL("image/png");
		const pxToMm = 25.4 / 96;
		const imgWidthMM = canvas.width * pxToMm;
		const imgHeightMM = canvas.height * pxToMm;

		const scale = pageWidth / imgWidthMM;
		const scaledWidth = imgWidthMM * scale;
		const scaledHeight = imgHeightMM * scale;

		let yPos = 0;
		let xPos = 0;
		let remainingHeight = scaledHeight;
		let remainingWidth = scaledWidth;

		while (remainingHeight > 0) {
			while (remainingWidth > 0) {
				pdf.addImage(
					imgData,
					"PNG",
					-xPos,
					-yPos,
					scaledWidth,
					scaledHeight
				);

				remainingWidth -= pageWidth;
				xPos += pageWidth;

				if (remainingWidth > 0) pdf.addPage();
			}

			remainingWidth = scaledWidth;
			xPos = 0;
			remainingHeight -= pageHeight;
			yPos += pageHeight;

			if (remainingHeight > 0) pdf.addPage();
		}

		pdf.save("table_report.pdf");
	};

	reportBody() {
		return (
			<Row className="p-1 report-preview">
				<Col md={12} className="p-1">
					<Card className="p-1 report-preview-card">
						<CardBody className="report-padding pb-0">
							<div className="report-body flex-sm-row flex-column  mt-0">
								<div className=" ">
									<h5 className="card-title-16 pt-2 ">
										SRI LALITHA ENTERPRISES INDUSTRIES PVT.
										LTD
									</h5>
									<p className="card-title-14 pt-2 mb-0">
										Valuthimmapuram Road, PEDDAPURAM -
										533437, E.G. Dist. - AP
									</p>
									<p className="card-title-14 pt-2 mb-0">
										Phone No.0884-2326661, 62, Mobile
										No.9494127893,
									</p>
									<p className="card-title-14 pt-2 mb-0">
										Email: purchase@sleipl.com,
										lalitharice@gmail.com
									</p>
									<p className="card-title-14 pt-2">
										GSTIN : 37AAKCS3233N1ZX
									</p>
								</div>
								<div className="pt-2">
									<span className="p-4">
										<img
											className="img-fluid p-0"
											src={SLE_logo}
											alt="Logo"
											width="100"
											height="120"
										/>
									</span>
									<h4 className="report-title mb-0">
										PURCHASE INDENT
									</h4>
									<h5 className="report-title">
										<span className="report-number">
											#{this.props.PI_Doc_report.code}
										</span>
									</h5>
								</div>
							</div>
							<hr className="hr-black-color " />

							<div className="report-body flex-sm-row flex-column mt-0">
								<div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Create By:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PI_Doc_report
													.createdby?.fullname
											}{" "}
											(
											{
												this.props.PI_Doc_report
													.createdby?.username
											}
											)
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Location:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PI_Doc_report
													.location?.name
											}
										</p>
									</div>

									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Department:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PI_Doc_report
													.userdepartment?.name
											}
										</p>
									</div>
								</div>
								<div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Status:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PI_Doc_report
													.pistatus_name
											}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Create Date:
										</p>
										<p className="report-wrapper-det">
											{moment(
												this.props.PI_Doc_report
													.createdon
											).format("DD-MM-YYYY")}
										</p>
									</div>
								</div>
							</div>
							<hr className="hr-black-color " />
							<div className="table-responsive m-0">
								<Table
									// striped
									bordered
									// hover
									className="mb-0 p-0 table-centered table-color-black">
									<thead className="bg-light text-center">
										<tr>
											<th style={{ width: "5%" }}>
												S.NO
											</th>
											<th style={{ width: "40%" }}>
												Item Name
											</th>
											<th style={{ width: "20%" }}>
												Quantity
											</th>
											<th style={{ width: "25%" }}>
												Approved Qty
											</th>
											<th style={{ width: "10%" }}>
												Status
											</th>
										</tr>
									</thead>
									<tbody>
										{this.props.PI_Doc_report?.piitems?.map(
											(item, key) => (
												<tr key={key}>
													<td className="text-center">
														{key + 1}
													</td>
													<td>
														<h5 className="font-size-14 ">
															{
																item?.product
																	?.name
															}
														</h5>
														<p className="mb-0">
															Make :{" "}
															<span className="font-weight-medium">
																{item.make}
															</span>
														</p>
														<p className="mb-0">
															Description :{" "}
															<span className="font-weight-medium">
																{
																	item.description
																}
															</span>
														</p>
														<p className="mb-0 text-black">
															<b
																style={{
																	fontWeight: 800,
																}}>
																Highest Price :
															</b>{" "}
															<span
																style={{
																	fontWeight: 800,
																}}
																className="font-weight-medium text-black">
																{
																	item
																		.highest_purchase_baseprice
																		?.baseprice
																}
																(
																{
																	item
																		.highest_purchase_baseprice
																		?.pocode
																}
																)<br />(
																{
																	item
																		.highest_purchase_baseprice
																		?.vendor
																}
																)
															</span>
														</p>
														<p className="mb-0 text-black">
															<b
																style={{
																	fontWeight: 800,
																}}>
																Lowest Price :
															</b>{" "}
															<span
																style={{
																	fontWeight: 800,
																}}
																className="font-weight-medium text-black">
																{
																	item
																		.lowest_purchase_baseprice
																		?.baseprice
																}
																(
																{
																	item
																		.lowest_purchase_baseprice
																		?.pocode
																}
																)<br />(
																{
																	item
																		.lowest_purchase_baseprice
																		?.vendor
																}
																)
															</span>
														</p>
														<p className="mb-0 text-black">
															<b
																style={{
																	fontWeight: 800,
																}}>
																Latest Price :
															</b>{" "}
															<span
																style={{
																	fontWeight: 800,
																}}
																className="font-weight-medium text-black">
																{
																	item
																		.last_purchase_baseprice
																		?.baseprice
																}
																(
																{
																	item
																		.last_purchase_baseprice
																		?.pocode
																}
																)<br />(
																{
																	item
																		.last_purchase_baseprice
																		?.vendor
																}
																)
															</span>
														</p>
														{/* <p className="mb-0 text-black">
                            <b style={{ fontWeight: 800 }}>MR Codes :</b>{" "}
                            <span
                              style={{ fontWeight: 800 }}
                              className="font-weight-medium text-black"
                            >
                              {item.mr_codes?.map((c) => c.code).join(", ")}
                            </span>
                          </p> */}
														{item.pistatus ===
															4 && (
															<p className="mb-0">
																<b className="text-danger ">
																	Reject
																	Remark :
																</b>{" "}
																<span>
																	{
																		item
																			.pii_approvals[
																			item
																				.pii_approvals
																				.length -
																				1
																		]
																			.description
																	}
																</span>
															</p>
														)}
													</td>
													<td className="text-center">
														{item.pii_approvals
															.length === 0
															? item.qty +
															  " " +
															  item.unit?.name
															: item
																	.pii_approvals[0]
																	.f_qty +
															  " " +
															  item
																	.pii_approvals[0]
																	.f_unit
																	.name}
													</td>

													<td className="text-center">
														{item.qty}{" "}
														{item.unit?.name}
													</td>

													<td className="nowrap text-center">
														{item.pistatus_name}
													</td>
												</tr>
											)
										)}
									</tbody>
								</Table>
								{/* </TableScrollbar> */}
							</div>
						</CardBody>
					</Card>
				</Col>
			</Row>
		);
	}
	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom no-print ">
										<Link
											to="#"
											onClick={() =>
												this.props.history.goBack()
											}
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										<div className="float-right">
											<div className="d-inline-block ">
												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() =>
														this.getPDFReport()
													}>
													<i className="ri-file-excel-2-line"></i>
													<span className="d-none d-inline-block ml-1">
														PDF
													</span>
												</Button>

												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() =>
														window.print()
													}>
													<i className="mdi  mdi-printer"></i>
													<span className="d-none d-inline-block ml-1">
														Print
													</span>
												</Button>
											</div>
										</div>
									</CardHeader>
									<CardBody
										className="pt-1 mr-auto mx-auto"
										id="toPdf">
										{this.reportBody()}
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { PI_Doc_report } = state.reports;
	return {
		PI_Doc_report,
	};
};

export default connect(mapStatetoProps, {
	getPIDocReport,
})(PIReportDocument);
